import React from "react";
import {
  Autocomplete,
  FormControl,
  FormHelperText,
  ListItem,
  ListItemText,
  Paper,
  TextField,
} from "@mui/material";
import styles from "./AutoCompleteField.module.css";
import addBoxIcon from "../../assets/images/add-box.svg";
import deleteIcon from "../../assets/images/delete-dustbin.svg";

function AddAutoCompleteField(props: any) {
  const {
    options,
    onChange,
    disableClearable,
    value,
    required = false,
    label,
    optionLabel,
    id,
    validState,
    disabled = false,
    onAddClick,
    onDeleteClick,
  } = props;
  return (
    <div>
      <FormControl fullWidth variant="standard" className="formControl">
        {label && (
          <div
            style={{
              fontSize: "12px",
              color: "#142C44",
              fontWeight: "500",
              fontFamily: "Poppins",
              display: "flex",
              margin: "0px 0px 5px",
            }}
          >
            {label}
            {required === true && (
              <span style={{ margin: "0px 4px", color: "#D32F2F" }}>*</span>
            )}
          </div>
        )}

        {options && (
          <Autocomplete
            disablePortal
            id={id}
            // options={options}
            // getOptionLabel={(option: any) => option[optionLabel] || ""}
            options={[{ isAddButton: true }, ...options]} // Prepend Add button option
            getOptionLabel={(option: any) =>
              option.isAddButton ? "Add New" : option[optionLabel] || ""
            }
            fullWidth
            onChange={onChange}
            value={value || null}
            disableClearable={disableClearable}
            // placeholder="dwd"
            renderInput={(params) => (
              <TextField
                variant="outlined"
                {...params}
                size="small"
                error={!validState}
              />
            )}
            renderOption={(props: any, option: any) => {
              if (option.isAddButton) {
                return (
                  <ListItem
                    {...props}
                    key="add-button"
                    onMouseDown={(e) => e.stopPropagation()}
                    sx={{
                      padding: "0 !important",
                      //   "&:hover": { backgroundColor: "#fff !important" },
                    }}
                  >
                    <button
                      onMouseDown={(e) => {
                        e.stopPropagation();
                        onAddClick?.();
                      }}
                      className={styles.addBtn}
                    >
                      <img src={addBoxIcon} alt="" />
                      Add Facebook Account
                    </button>
                  </ListItem>
                );
              }
              return (
                <ListItem
                  {...props}
                  key={option.firstName + option.lastName}
                  secondaryAction={
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onDeleteClick?.(option);
                      }}
                      className={styles.deleteBtn}
                    >
                      <img
                        src={deleteIcon}
                        alt="icon"
                        style={{ maxWidth: "100%" }}
                      />
                    </button>
                  }
                >
                  <ListItemText
                    primary={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          textTransform: "capitalize",
                          color: "#667085",
                          fontSize: "14PX",
                        }}
                      >
                        {optionLabel === "ASSIGNEE" && (
                          <div
                            style={{
                              width: 24,
                              height: 24,
                              backgroundColor: "#F5F5F7",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: 6,
                              textTransform: "uppercase",
                              color: "#667085",
                              fontSize: "10px",
                              fontWeight: "500",
                              padding: "5px 7px 3px 7px",
                            }}
                          >
                            {option?.firstName?.[0] + option?.lastName?.[0]}
                          </div>
                        )}

                        {option[optionLabel]}
                      </div>
                    }
                  />
                </ListItem>
              );
            }}
            // PaperComponent={(props) => (
            //   <Paper
            //     sx={{
            //       background: "#FFF",
            //       border: "1px solid #E4E4E7",
            //       fontFamily: "poppins",
            //       fontSize: "14px",
            //       textTransform: "capitalize",
            //       color: "142C44",
            //       fontWeight: "400",
            //       padding: "0 4px !important",
            //       margin: "0",
            //       boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.06)",
            //       maxHeight: "300px",
            //       overflowY: "auto",
            //     }}
            //     {...props}
            //   />
            // )}
            disabled={disabled}
          />
        )}
        {validState === false && required && (
          <FormHelperText error={true}>Field required</FormHelperText>
        )}
      </FormControl>
    </div>
  );
}

export default AddAutoCompleteField;
